module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg24.d72b4f21.jpg";